module.exports = __webpack_public_path__ + "img/Avatar-74.55ff89f0.svg";